import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20technology%20background%20with%20flowing%20warm%20orange%20and%20cream%20gradients%2C%20soft%20geometric%20patterns%2C%20clean%20minimalist%20digital%20aesthetic%2C%20smooth%20curves%20and%20subtle%20light%20effects%2C%20professional%20atmosphere%2C%20warm%20inviting%20tones&width=1800&height=900&seq=hero-bg-jiujiu-01&orientation=landscape"
          alt="久久在线 - 随时随地畅享在线服务"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <i className="ri-sparkling-line text-white text-xs"></i>
            <span className="text-white/90 text-xs font-medium">2026 全新版本正式发布</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
            随时随地，畅享
            <span className="text-primary-300">在线服务</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed mb-8">
            久久在线为您提供稳定、高速、全天候的在线服务体验。无论何时何地，久久在线都能满足您的需求，让您享受流畅、安全、便捷的数字生活。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              免费开始使用
              <i className="ri-arrow-right-line ml-2 text-xs"></i>
            </a>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-6 md:gap-12 mt-12 max-w-lg mx-auto">
            {[
              { value: '100万+', label: '服务用户' },
              { value: '99.99%', label: '服务可用性' },
              { value: '7×24h', label: '全天候服务' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}